import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { getInviteDetailsAsync, selectInviteDetails } from './InviteSlice'
import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material'

const InviteLandingPage = () => {
  const { slug } = useParams()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    if (slug) {
      dispatch(getInviteDetailsAsync({ slug }))
    }
  }, [])
  const selectedInviteDetails = useAppSelector(selectInviteDetails)
  return slug && selectedInviteDetails ? <Box>
    <Card sx={{ py: 5 }}>
      <CardContent>
        <Typography variant="h4" component="div" gutterBottom>        Welcome to RentFinder.ai      </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          You have been invited by <i>{selectedInviteDetails.invitedBy}</i>
        </Typography>
        <Typography variant="body2" sx={{ mt: 7 }}>
          Please use <strong><i>{selectedInviteDetails.userEmail}</i></strong>
          <span>&nbsp;</span> email to signup. You will be added to their team
          <strong><i>{selectedInviteDetails.org?.name}</i></strong>
          <span>&nbsp;</span> automatically after signup.
        </Typography>
        <Typography sx={{ fontSize: 10, mb: 3 }} color="text.secondary" gutterBottom>
          Invited by {slug}
        </Typography>
      </CardContent>
      <CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant='contained' size="small" onClick={() => navigate(`/login`)}>Signup</Button>
      </CardActions>
    </Card>
  </Box> : <></>
}

export default InviteLandingPage